import React from 'react'

function Icon({color = '#1A1A1A', strokeWidth = '0'}) {
    return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <mask
                id="mask0_6309_99345"
                style={{ maskType: 'alpha' }}
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="16"
                height="16"
            >
                <rect width="16" height="16" fill="#D9D9D9" />
            </mask>
            <g mask="url(#mask0_6309_99345)">
                <path
                    d="M8.0026 9.58464C7.93594 9.58464 7.87216 9.57352 7.81127 9.5513C7.74994 9.52908 7.68594 9.48464 7.61927 9.41797L4.7026 6.5013C4.62483 6.42352 4.58594 6.34286 4.58594 6.2593C4.58594 6.17619 4.62483 6.1013 4.7026 6.03464C4.76927 5.95686 4.84705 5.91797 4.93594 5.91797C5.02483 5.91797 5.1026 5.95686 5.16927 6.03464L8.0026 8.8513L10.8359 6.01797C10.9026 5.9513 10.9804 5.91797 11.0693 5.91797C11.1582 5.91797 11.2359 5.95686 11.3026 6.03464C11.3804 6.1013 11.4193 6.17908 11.4193 6.26797C11.4193 6.35686 11.3804 6.43464 11.3026 6.5013L8.38594 9.41797C8.31927 9.48464 8.25549 9.52908 8.1946 9.5513C8.13327 9.57352 8.06927 9.58464 8.0026 9.58464Z"
                    fill={color}
                    stroke={color}
                    strokeWidth={strokeWidth}
                    strokeLinejoin="round"
                />
            </g>
        </svg>
    )
}

export default Icon
